import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/form-cc-properties"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formCCPropertiesApi = createApi({
    reducerPath: "formCCPropertiesApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ["CCProperties"],
    endpoints: (builder) => ({
        getCCProperties: builder.query({
            query: ({ elementId, movementId }) =>
                `/?element-id=${elementId}&movement-id=${movementId}`,
            transformResponse: (response) => response.data,
            providesTags: ["CCProperties"],
        }),
        saveCCProperty: builder.mutation({
            query: (obj) => ({
                url: `/`,
                method: "POST",
                body: obj,
                transformResponse: (response) => response.data,
            }),
            invalidatesTags: ["CCProperties"],
        }),
    }),
});

export const {
    useGetCCPropertiesQuery,
    useSaveCCPropertyMutation
} = formCCPropertiesApi;
